var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInstructions = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white",
    stroke: "var(--asset-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9 11.4477 9.44772 11 10 11H24C24.5523 11 25 11.4477 25 12C25 12.5523 24.5523 13 24 13H10C9.44772 13 9 12.5523 9 12ZM9 17C9 16.4477 9.44772 16 10 16H24C24.5523 16 25 16.4477 25 17C25 17.5523 24.5523 18 24 18H10C9.44772 18 9 17.5523 9 17ZM10 21C9.44772 21 9 21.4477 9 22C9 22.5523 9.44772 23 10 23H20C20.5523 23 21 22.5523 21 22C21 21.4477 20.5523 21 20 21H10Z",
    fill: "var(--asset-color)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstructions, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instructions.996dc9a7.svg";
export { ForwardRef as ReactComponent };